module.exports = __webpack_public_path__ + "img/coal.93351954.png";